(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { gql as x, useQuery as ie, useLazyQuery as Oe, useMutation as $, isApolloError as ve } from "@apollo/client";
import { getOperationName as H } from "@apollo/client/utilities";
import { jsx as i, jsxs as m, Fragment as W } from "react/jsx-runtime";
import { FormField as B, FieldWrapper as v, Badge as q, Icon as J, FlexBox as b, Text as M, List as ne, Banner as re, Button as k, Modal as xe, ModalHead as Pe, ModalBody as We, ModalFoot as ke, Spinner as Y, Tag as Le, Tooltip as se, FieldSwitch as Re, InputSelectionList as _e, SelectionList as $e } from "@dixa/lib-shared-habla";
import { Link as Be } from "react-router-dom";
import { colors as I } from "@dixa/lib-shared-tokens";
import { useState as u, useEffect as D, createContext as ae, useContext as ce, createElement as Q, useCallback as U } from "react";
import { FormProvider as Fe } from "react-hook-form";
import le from "moment";
import { useInterval as Ge } from "react-use";
import Ue from "lodash/lowerCase";
import He from "lodash/upperFirst";
import { HookFormText as Ke } from "lib-shared-hook-form";
import { MockedProvider as ze } from "@apollo/client/testing";
import { render as Qe } from "@testing-library/react";
const de = x`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, ue = x`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, ge = x`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, me = x`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, Ht = (e, t) => function(n, o) {
  return ie(n, {
    ...o,
    context: {
      operationName: H(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, Kt = (e, t) => function(n, o) {
  return Oe(n, {
    ...o,
    context: {
      operationName: H(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, zt = (e, t, n) => function(o, r) {
  return n.query({
    query: o,
    variables: r,
    context: {
      operationName: H(o),
      widgetId: e,
      widgetType: t
    }
  });
}, Qt = (e, t) => function(n, o) {
  return $(n, {
    ...o,
    context: {
      operationName: H(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, Vt = ({
  getValueByKey: e
}) => {
  const t = e("dixaApiTokenId")?.value, n = e("dixaApiTokenName")?.value;
  return /* @__PURE__ */ i(B, { children: /* @__PURE__ */ i(v, { label: "Dixa API-Token", children: !n || !t ? /* @__PURE__ */ i(W, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ m(W, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ i(q, { variant: "secondary", size: "small", children: n }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ i(Be, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, Ve = ({
  error: e
}) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", qt = ({
  errors: e
}) => e.some((t) => Ve({ error: t })), qe = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", Jt = ({
  errors: e
}) => e.some((t) => qe({ error: t })), Je = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", Yt = ({
  errors: e
}) => e.some((t) => Je({ error: t })), Ye = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", Zt = ({
  errors: e
}) => e.some((t) => Ye({ error: t })), Ze = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", jt = ({
  errors: e
}) => e.some((t) => Ze({ error: t })), je = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", Xt = ({
  errors: e
}) => e.some((t) => je({ error: t })), Xe = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", en = ({
  errors: e
}) => e.some((t) => Xe({ error: t })), et = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", tn = ({
  errors: e
}) => e.some((t) => et({ error: t })), tt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", nn = ({
  errors: e
}) => e.some((t) => tt({ error: t })), nt = ({
  error: e
}) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", ot = ({
  errors: e
}) => e.some((t) => nt({ error: t })), it = (e) => {
  const { delay: t = 2e3 } = e || {}, [n, o] = u(!1);
  return D(() => {
    const s = n ? window.setTimeout(() => o(!1), t) : void 0;
    return () => window.clearTimeout(s);
  }, [t, n]), { isCopied: n, copy: (s) => {
    navigator.clipboard.writeText(s), o(!0);
  } };
}, rt = "_errorWrapper_171rr_1", st = "_copyIcon_171rr_5", V = {
  errorWrapper: rt,
  copyIcon: st
}, fe = ({
  error: e,
  retry: t,
  isMisconfigured: n = !1,
  hideCopyButton: o = !1
}) => {
  const s = e && ve(e) && e?.graphQLErrors?.length > 0, { isCopied: a, copy: g } = it(), d = /* @__PURE__ */ i(
    J,
    {
      color: I.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (n || s && ot({
    errors: e.graphQLErrors
  }))
    return /* @__PURE__ */ m(b, { margin: "0 0 100", padding: "200", className: V.errorWrapper, children: [
      /* @__PURE__ */ i(b, { margin: "0 300 0 0", alignItems: "center", children: d }),
      /* @__PURE__ */ i(M.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!s)
    return /* @__PURE__ */ i(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ i(
      ne.Item,
      {
        contentLeft: d,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const f = e?.graphQLErrors || [];
  return /* @__PURE__ */ m(
    b,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: V.errorWrapper,
      children: [
        f.map((c, h) => {
          const p = c?.extensions?.integration, C = p?.message || e?.message || "No error message available", y = p?.responseBody && JSON.parse(p?.responseBody), E = y?.errorMessages || [], A = y?.warningMessages || [], l = [...E, ...A].join(" ");
          return /* @__PURE__ */ i(
            ne.Item,
            {
              title: C,
              titleSecondary: l,
              contentLeft: d
            },
            h
          );
        }),
        !o && /* @__PURE__ */ m(b, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ i(
            re,
            {
              variant: "info",
              description: /* @__PURE__ */ i(M.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ m(b, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ i(k, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ i(
              k,
              {
                variant: "secondary",
                icon: a ? "done" : "copy",
                onClick: () => g(JSON.stringify(f, null, 2)),
                className: V.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, at = ({
  headline: e,
  text: t,
  children: n,
  onConfirm: o,
  onCancel: r,
  confirmLabel: s,
  cancelLabel: a = "Cancel",
  confirmVariant: g = "primary",
  cancelVariant: d = "secondary",
  isOpen: f,
  setIsOpen: c,
  showOnClose: h = !1
}) => /* @__PURE__ */ m(
  xe,
  {
    isOpen: f,
    onClose: () => {
      r && r(), c(!1);
    },
    children: [
      /* @__PURE__ */ i(
        Pe,
        {
          title: e,
          onClose: h ? r : void 0
        }
      ),
      /* @__PURE__ */ m(We, { children: [
        t && /* @__PURE__ */ i("div", { style: { width: "600px" }, children: t }),
        n
      ] }),
      /* @__PURE__ */ i(
        ke,
        {
          confirmOnClick: o ? () => {
            o(), c(!1);
          } : void 0,
          cancelOnClick: () => {
            r && r(), c(!1);
          },
          confirmName: s,
          cancelName: a,
          confirmProps: { variant: g },
          cancelProps: { variant: d }
        }
      )
    ]
  }
), Z = "The configuration of the integration is not correct. Please check the settings.", on = ({
  cause: e
}) => /* @__PURE__ */ i(b, { margin: "0 0 400", children: /* @__PURE__ */ i(
  re,
  {
    variant: "fail",
    headline: "This integration is misconfigured",
    description: /* @__PURE__ */ m(b, { gap: "300", flexDirection: "column", children: [
      /* @__PURE__ */ i(M.Paragraph, { children: e || Z }),
      /* @__PURE__ */ m(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ i(M.Heading, { variant: "heading-3", children: "Additional information" }),
        /* @__PURE__ */ i(M.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
      ] })
    ] })
  }
) }), rn = ({
  form: e,
  integrationId: t,
  onValidSubmit: n,
  error: o,
  onRetry: r,
  isLoading: s,
  isWidgetUnknown: a,
  children: g
}) => o ? /* @__PURE__ */ i(fe, { error: o, retry: r }) : s ? /* @__PURE__ */ i(Y, { "data-testid": "widget-settings-loading" }) : a ? /* @__PURE__ */ m(M.Paragraph, { children: [
  "A widget with the id ",
  /* @__PURE__ */ i(Le, { children: t }),
  " does not exist."
] }) : /* @__PURE__ */ i(Fe, { ...e, children: /* @__PURE__ */ i(
  "form",
  {
    noValidate: !0,
    tabIndex: -1,
    "data-testid": `widget-settings-form-${t ?? "create-new"}`,
    onSubmit: e.handleSubmit(n),
    children: g
  }
) });
function sn(e, t = !0) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const an = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, cn = (e) => {
  const t = Ue(e);
  return t.length === 0 ? e : He(t);
}, he = "DD MMM YYYY @ HH:mm";
function ct(e, t) {
  return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function lt(e, t) {
  return e == null ? t : String(e);
}
function ln(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const dn = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], un = (e) => {
  if (!e?.trim())
    return "Please add a valid subdomain";
  const n = ["https://", "http://"].find(
    (s) => e.startsWith(s)
  ), o = n ? `Please remove the protocol \`${n}\` from the hostname` : "", r = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (o && r)
    return `Please remove the protocol \`${n}\` and the trailing \`/\` from the hostname`;
  if (o)
    return o;
  if (r)
    return r;
};
function dt(e) {
  const t = e.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const n = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(n).toString());
  } catch (o) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${o}`
    );
  }
}
const pe = ae(null), ut = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pe.Provider
);
function Ce() {
  const e = ce(pe);
  if (e === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return e;
}
const gt = {
  useMutation: $,
  useQuery: () => {
  },
  useLazyQuery: () => {
  },
  executeQuery: () => {
  },
  showNotification: () => {
  },
  showModal: () => {
  }
}, mt = {
  baseUrl: "http://localhost/graphql"
};
function gn(e, { mocks: t = [], overrides: n = {} } = {}) {
  const o = vi.fn(), r = vi.fn(), a = { ...{
    configuration: mt,
    handleRedirect: o,
    showNotification: r
  }, ...n };
  return { ...Qe(
    Q(
      ze,
      { mocks: t },
      Q(
        ut,
        { value: gt },
        Q(e, a)
      )
    )
  ), handleRedirect: o, showNotification: r };
}
function mn({
  id: e,
  configuration: t
}) {
  const n = t?.settings ?? [];
  return {
    request: {
      query: de,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          widgetConfigurations: [
            {
              id: e,
              type: t?.type ?? "UNKNOWN",
              name: t?.name ?? "Test widget",
              enabled: t?.enabled ?? !0,
              misconfigured: t?.misconfigured ?? !1,
              misconfigurationCause: t?.misconfigurationCause ?? null,
              additionalProperties: t?.additionalProperties ?? null,
              settings: n
            }
          ]
        }
      }
    }
  };
}
function fn({
  variables: e,
  result: t
}) {
  return {
    request: {
      query: ge,
      variables: e
    },
    result: {
      data: {
        Management: {
          createWidgetConfiguration: {
            id: t?.id ?? "new-id",
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function hn({
  variables: e,
  result: t
}) {
  return {
    request: {
      query: ue,
      variables: e
    },
    result: {
      data: {
        Management: {
          updateWidgetConfiguration: {
            id: e.id,
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled ?? !0,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function pn({
  id: e
}) {
  return {
    request: {
      query: me,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          deleteWidgetConfiguration: { id: e }
        }
      }
    }
  };
}
function ft(e, t) {
  const n = {};
  for (const o of t) {
    const s = e.find((a) => a.key === o.key)?.value;
    o.secret && s === void 0 || (o.type === "boolean" ? n[o.key] = ct(s, o.defaultValue) : n[o.key] = lt(s, o.defaultValue));
  }
  return n;
}
function ht(e, t) {
  return t.filter((n) => e[n.key] !== void 0).map((n) => ({
    key: n.key,
    value: String(e[n.key]),
    secret: n.secret
  }));
}
async function Cn(e, {
  fieldDefinitions: t,
  isCreationMode: n,
  create: o,
  update: r
}) {
  const s = ht(e, t), a = {
    name: e.name,
    enabled: e.enabled,
    settings: s
  };
  n ? await o(a) : await r(a);
}
function pt(e) {
  const { user_id: t, iss: n } = dt(e);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": n
  };
}
function Ct(e) {
  return e.startsWith("http://localhost");
}
const yt = ae(null);
function Et() {
  const e = ce(yt);
  if (e === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return e;
}
function yn() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
function j() {
  return { track: (t, n) => window._partner.events.emit(t, n) };
}
const wt = (e) => {
  switch (e) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: I.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: I.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: I.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: I.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: I.neutral[500],
        tooltip: "Not connected"
      };
  }
}, En = ({
  configuration: e,
  integrationId: t,
  integrationType: n,
  label: o
}) => {
  const [r, s] = u("CONNECTING"), [a, g] = u(""), [d, f] = u(null), { track: c } = j(), { icon: h, color: p, tooltip: C } = wt(r), y = 3, E = 15, A = 2e3, [l, N] = u({}), [S, P] = u(0), [L, O] = u(A), [ye, K] = u(!1), [Ee, we] = u(y), {
    isInboundOAuth: Ae,
    setIsInboundOAuth: be,
    hasTriggeredAuthorization: Ne,
    setHasTriggeredAuthorization: Se
  } = Et(), { baseUrl: F } = e, De = `${F}/auth/connect/${n.toLowerCase()}/${t}`, Me = `${F}/auth/status/${n.toLowerCase()}/${t}`, X = r === "CONNECTING", ee = (w) => Object.keys(w).length === 0, z = () => {
    K(!1), P(0);
  };
  D(() => {
    const w = localStorage.getItem("authData");
    if (w) {
      const T = JSON.parse(w ?? "{}").access_token;
      N({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${T}`,
          ...Ct(F) && pt(T)
        }
      });
    }
  }, [F]), D(() => {
    ee(l) || K(!0);
  }, [l]);
  const Te = () => {
    we(E), fetch(Me, { ...l }).then((w) => w.json()).then(({ data: w }) => {
      const { status: R, createdAt: T, createdByName: _ } = w;
      switch (R) {
        case "CONNECTING":
          s("CONNECTING");
          break;
        case "CONNECTED": {
          if (c("settings:view:oauth:succeeded", {
            widgetId: t,
            widgetType: n
          }), s("CONNECTED"), T && _) {
            const G = new Date(T);
            isNaN(G.getTime()) || f(G), g(_);
          }
          z();
          break;
        }
        case "NOT_CONNECTED":
        case "CONNECTION_FAILED":
          s(R), z();
      }
    }).catch((w) => {
      console.warn(
        `Fetching OAuth status failed for ${n} ${t}`,
        w
      ), s("CONNECTION_FAILED");
    });
  };
  Ge(
    () => {
      S >= Ee ? (s("CONNECTION_TIMEOUT"), z()) : (Te(), P(S + 1));
    },
    ye ? L : null
  );
  const te = () => {
    c("settings:view:oauth:started", {
      widgetId: t,
      widgetType: n
    }), fetch(De, { ...l }).then((w) => w.json()).then(({ data: w }) => {
      const { url: R } = w, T = 620, _ = 800, G = window.innerWidth / 2 - T / 2, Ie = window.innerHeight / 2 - _ / 2;
      s("CONNECTING"), K(!0), window.open(
        R,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${T},
						height=${_},
						left=${G},
						top=${Ie}`
      );
    }).catch((w) => {
      console.warn(
        `Fetching OAuth connection failed for ${n} ${t}`,
        w
      ), s("CONNECTION_FAILED");
    });
  };
  return D(() => {
    Ae && !Ne && !ee(l) && (Se(!0), be(!1), te());
  }, [l]), /* @__PURE__ */ m(W, { children: [
    /* @__PURE__ */ i(B, { span: 3, children: /* @__PURE__ */ i(
      v,
      {
        label: o,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ m(b, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ i(
            k,
            {
              icon: "key",
              variant: "secondary",
              onClick: te,
              disabled: X,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ i(se, { content: C, children: X ? /* @__PURE__ */ i(Y, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ m(b, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ i(
              J,
              {
                "data-testid": "oauth-button-status-icon",
                name: h,
                color: p
              }
            ),
            r === "CONNECTED" && a && d && /* @__PURE__ */ m(M.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              a,
              " at",
              " ",
              le(d).format(he)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ i(B, { span: 3 })
  ] });
}, At = "_settingsWrapper_eleyu_1", bt = {
  settingsWrapper: At
}, Nt = x`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, oe = [], wn = ({
  settings: e,
  getValueByKey: t,
  handleChangeSelect: n
}) => {
  const o = "subscriptionListId", s = e?.find(
    (l) => l.key === o
  )?.label ?? "Activate re-/subscription list selection", a = t(o)?.value, { useQuery: g } = Ce(), [d, f] = u(oe), [c, h] = u(!!a), [p, C] = u(a), {
    data: y,
    error: E,
    loading: A
  } = g(Nt, {
    skip: !c,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return D(() => {
    a && (C(a), h(!0));
  }, [a]), D(() => {
    const l = y?.Klaviyo?.get_lists;
    if (c && l && !A && !E) {
      const N = l?.data?.map(
        (S) => ({
          value: S?.id,
          label: S?.attributes?.name
        })
      ) || oe;
      f(N);
    }
  }, [c, y, A, E]), /* @__PURE__ */ m(W, { children: [
    /* @__PURE__ */ i(B, { span: 3, children: /* @__PURE__ */ m(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: bt.settingsWrapper,
        children: [
          /* @__PURE__ */ i(v, { label: s, children: /* @__PURE__ */ i(
            Re,
            {
              input: {
                name: `${o}-switch`,
                value: "switchValueFromComponent",
                checked: c,
                onChange: () => {
                  const l = !c;
                  l || n(o, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), h(l);
                }
              }
            }
          ) }),
          c && E && !A && /* @__PURE__ */ i(v, { children: /* @__PURE__ */ i(fe, { error: E }) }),
          c && !E && A && /* @__PURE__ */ i(v, { children: /* @__PURE__ */ i(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ i(Y, {}) }) }),
          c && !E && !A && d && /* @__PURE__ */ i(v, { label: "Available lists to subscribe to", children: /* @__PURE__ */ i(
            _e,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (l) => {
                n(o, l), C(l?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (l) => l ? /* @__PURE__ */ i(M.Paragraph, { children: l.label }) : null,
              value: p ? [
                {
                  label: (d || []).find(
                    (l) => l.value === p
                  )?.label,
                  value: p
                }
              ] : [],
              equalityFn: (l, N) => l.value === N.value,
              children: d.map((l) => /* @__PURE__ */ i($e.Item, { value: l, children: l.label }, l.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ i(B, { span: 3 })
  ] });
}, An = (e) => {
  if (e == null)
    return null;
  if (Array.isArray(e))
    return /* @__PURE__ */ i(M.Paragraph, { variant: "5", color: "secondary", align: "right", children: e.join(", ") });
  if (typeof e == "boolean" || e === "true" || e === "false") {
    const o = e === "true" || e === !0;
    return /* @__PURE__ */ i(
      J,
      {
        name: o ? "check-circle-filled" : "close-circle-filled",
        color: o ? I.green[500] : I.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${o ? "true" : "false"}`
      }
    );
  }
  if (typeof e == "number" || /^\d*\.?\d+$/.test(e))
    return /* @__PURE__ */ i(q, { variant: "success", size: "small", children: e });
  if (e.startsWith("days_ago: ")) {
    const o = e.replace("days_ago: ", ""), r = o.startsWith("-"), s = o === "0", a = r ? `${o.replace("-", "")} days ago` : `in ${o} days`;
    return /* @__PURE__ */ i(M.Paragraph, { variant: "5", color: "secondary", children: s ? "today" : a });
  }
  const n = le(e);
  return n.isValid() ? /* @__PURE__ */ i(M.Paragraph, { variant: "5", color: "secondary", children: n.format(he) }) : /* @__PURE__ */ i(q, { variant: "info", size: "small", children: e });
}, bn = (e) => {
  const { isCreationMode: t = !1, label: n, helpIcon: o, name: r } = e, [s, a] = u(t);
  if (!s) {
    const g = typeof n == "string" ? n : "";
    return /* @__PURE__ */ i(v, { label: n, helpIcon: o, children: /* @__PURE__ */ m(
      k,
      {
        "data-testid": `secret-field-button-${r}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => a(!0),
        children: [
          "Update ",
          g
        ]
      }
    ) });
  }
  return /* @__PURE__ */ i(
    St,
    {
      ...e,
      isCreationMode: t,
      onClose: () => a(!1)
    }
  );
}, St = (e) => {
  const { isCreationMode: t, componentProps: n, onClose: o } = e, r = {
    ...n,
    prefix: t ? n?.prefix : {
      type: "button",
      button: { icon: "close", onClick: o }
    }
  };
  return /* @__PURE__ */ i(
    Ke,
    {
      ...e,
      componentProps: r,
      shouldUnregister: !0
    }
  );
}, Dt = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, Nn = ({
  integrationType: e,
  integrationId: t,
  widgetName: n,
  isCreationMode: o,
  isSubmitting: r,
  automationCouplingState: s,
  onConfirmDelete: a,
  labels: g,
  deleteConfirmationBody: d,
  confirmDeleteVariant: f = "primary"
}) => {
  const { track: c } = j(), [h, p] = u(!1), C = { ...Dt, ...g }, y = !s || !s.isCoupled, E = () => {
    t && c("settings:view:delete:requested", {
      widgetId: t,
      widgetType: e
    }), p(!0);
  }, A = () => {
    t && c("settings:view:delete:canceled", {
      widgetId: t,
      widgetType: e
    });
  };
  return /* @__PURE__ */ m(W, { children: [
    /* @__PURE__ */ m(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ i(k, { type: "submit", isLoading: r, disabled: r, children: C.submit }),
      !o && /* @__PURE__ */ i(
        se,
        {
          content: "The widget is used in automations",
          disabled: y,
          children: /* @__PURE__ */ i(
            k,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: E,
              disabled: !y,
              isLoading: s?.isLoading,
              children: C.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ i(
      at,
      {
        isOpen: h,
        setIsOpen: p,
        confirmVariant: f,
        confirmLabel: C.confirmDelete,
        cancelLabel: C.cancelDelete,
        onCancel: A,
        onConfirm: a,
        children: /* @__PURE__ */ i(b, { children: d ?? /* @__PURE__ */ m(W, { children: [
          "Are you sure you want to delete the ",
          e,
          ' integration "',
          n,
          '"?'
        ] }) })
      }
    )
  ] });
}, Mt = x`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Tt = x`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Sn(e) {
  const { useQuery: t, useMutation: n } = Ce(), [o, r] = u(), [s, a] = u(), [g, d] = u(!1), {
    loading: f,
    data: c,
    error: h
  } = t(
    Mt,
    {
      skip: !e,
      variables: {
        conversationId: e?.toString()
      }
    }
  ), [p, { loading: C, error: y }] = n(
    Tt
  ), E = async (A, l) => await p({
    variables: {
      conversationId: (l ?? e)?.toString(),
      data: A
    }
  }).then(
    ({ data: S }) => r(S?.Storage?.storeWidgetData?.data ?? {})
  );
  return D(() => {
    !f && c && r(c?.Storage?.widgetData ?? {});
  }, [c, f]), D(() => h && a(h), [h]), D(() => d(f), [f]), D(() => y && a(y), [y]), D(() => d(C), [C]), {
    data: o,
    loading: g,
    store: E,
    error: s
  };
}
const Dn = ({
  integrationId: e,
  integrationType: t,
  handleRedirect: n,
  showNotification: o
}) => {
  const { track: r } = j(), [s, a] = u(!1), [g, d] = u(), [f, c] = u(null), h = U(
    (N) => (S) => {
      d(S), a(!1), o({
        title: "Something went wrong",
        text: `The ${N} of the widget was not successful.`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    [o]
  ), [p] = $(ge, {
    onError: h("creation")
  }), [C] = $(ue, {
    onError: h("update")
  }), [y] = $(me, {
    onError: h("deletion")
  }), E = U(
    async ({ name: N, enabled: S, settings: P }) => {
      r("settings:create:submitted", { widgetType: t }), a(!0), d(void 0);
      const { data: L } = await p({
        variables: { type: t, name: N, enabled: S, settings: P }
      });
      a(!1);
      const O = L?.Management?.createWidgetConfiguration;
      if (!O) {
        o({
          title: "Something went wrong",
          text: "The creation of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      o({
        title: "Creating was successful",
        text: "Creating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), n(O.id);
    },
    [p, n, t, o, r]
  ), A = U(
    async ({ name: N, enabled: S, settings: P }) => {
      if (!e)
        return;
      r("settings:view:change:submitted", {
        widgetId: e,
        widgetType: t
      }), a(!0), d(void 0);
      const { data: L } = await C({
        variables: { id: e, name: N, enabled: S, settings: P }
      });
      a(!1);
      const O = L?.Management?.updateWidgetConfiguration;
      if (!O) {
        o({
          title: "Something went wrong",
          text: "The update of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      O.misconfigured ? c(
        O.misconfigurationCause ?? Z
      ) : c(null), o({
        title: "Updating was successful",
        text: "Updating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    },
    [e, t, o, r, C]
  ), l = U(async () => {
    if (!e)
      return;
    r("settings:view:delete:confirmed", {
      widgetId: e,
      widgetType: t
    }), a(!0), d(void 0);
    const { data: N } = await y({
      variables: { id: e }
    });
    a(!1), N?.Management?.deleteWidgetConfiguration && (n(), o({
      title: "Deletion was successful",
      text: "The deletion of the widget was successful.",
      icon: "check-circle-filled",
      severity: "success"
    }));
  }, [
    y,
    n,
    e,
    t,
    o,
    r
  ]);
  return {
    create: E,
    update: A,
    remove: l,
    isLoading: s,
    error: g,
    misconfigurationCause: f,
    setMisconfigurationCause: c
  };
};
function Mn({
  integrationId: e,
  fieldDefinitions: t,
  form: n,
  onMisconfigured: o
}) {
  const [r, s] = u(!1), { loading: a, error: g, refetch: d } = ie(de, {
    variables: { id: e },
    skip: !e,
    onCompleted: (f) => {
      const c = f?.Management?.widgetConfigurations?.[0];
      if (!c) {
        s(!0);
        return;
      }
      s(!1), n.reset({
        ...ft(c.settings ?? [], t),
        enabled: !!c.enabled,
        name: c.name
      }), c.misconfigured && o?.(
        c.misconfigurationCause ?? Z
      );
    }
  });
  return D(() => {
    e || s(!1);
  }, [e]), {
    isLoading: a,
    error: g,
    isWidgetUnknown: r,
    refetch: d
  };
}
export {
  fe as DisplayErrors,
  Vt as DixaApiTokenSettings,
  yt as InboundOAuthContext,
  at as IntegrationModal,
  wn as KlaviyoSubscribeSetting,
  on as MisconfigurationBanner,
  En as OAuthSettings,
  bn as PartnerHookFormSecretText,
  rn as PartnerSettingsWrapper,
  ut as WidgetContextProvider,
  Nn as WidgetSettingsFormFooter,
  an as capitalizeFirstCharacter,
  dn as countryCodes,
  yn as createMockInboundOAuthContextOptions,
  fn as createWidgetConfigurationCreateMock,
  pn as createWidgetConfigurationDeleteMock,
  ge as createWidgetConfigurationMutation,
  mn as createWidgetConfigurationQueryMock,
  hn as createWidgetConfigurationUpdateMock,
  sn as deepClone,
  he as defaultDateFormat,
  Z as defaultMisconfigurationCause,
  mt as defaultPartnerSettingsConfiguration,
  gt as defaultWidgetContextValue,
  me as deleteWidgetConfigurationMutation,
  An as displayAttributeValue,
  ht as formValuesToSettings,
  wt as getConnectionStatusValues,
  ln as getCountryNameFromCountryCode,
  Nt as getListsQuery,
  pt as getPartnerDevApiHeaders,
  de as getWidgetConfigurationByIdQuery,
  Cn as handleWidgetSubmit,
  qt as hasDixaHeaderCheckError,
  Jt as hasDownstreamApiAuthorizationError,
  en as hasDownstreamApiBadRequestError,
  Xt as hasDownstreamApiConflictError,
  tn as hasDownstreamApiForbiddenError,
  jt as hasDownstreamApiNotFoundError,
  Yt as hasDownstreamApiPermissionError,
  Zt as hasDownstreamApiServiceUnavailableError,
  nn as hasDownstreamApiTooManyRequestsError,
  ot as hasWidgetMisconfiguredError,
  cn as humanizeKey,
  Ve as isDixaHeaderCheckError,
  qe as isDownstreamApiAuthorizationError,
  Xe as isDownstreamApiBadRequestError,
  je as isDownstreamApiConflictError,
  et as isDownstreamApiForbiddenError,
  Ze as isDownstreamApiNotFoundError,
  Je as isDownstreamApiPermissionError,
  Ye as isDownstreamApiServiceUnavailableError,
  tt as isDownstreamApiTooManyRequestsError,
  Ct as isRunningLocalPartnerApi,
  nt as isWidgetMisconfiguredError,
  zt as makeExecuteQuery,
  Kt as makeUseLazyQuery,
  Qt as makeUseMutation,
  Ht as makeUseQuery,
  dt as parseAccessToken,
  ct as parseBoolean,
  lt as parseString,
  gn as renderPartnerSettings,
  ft as settingsToFormValues,
  ue as updateWidgetConfigurationMutation,
  it as useCopyWithDelay,
  Sn as useData,
  Et as useInboundOAuthContext,
  j as useTracking,
  Ce as useWidgetContext,
  Dn as useWidgetSettingsMutations,
  Mn as useWidgetSettingsQuery,
  un as validateApiHostName
};
